import React, { useEffect } from "react";
import "./Documentation.css";

const MACHINE_READABLE_LINKS = [
  {
    rel: "alternate",
    type: "text/html",
    href: "https://forexapi.ibrlive.com/api-documentation.html",
    title: "IBR Live Forex API documentation (full HTML)",
  },
  {
    rel: "alternate",
    type: "text/plain",
    href: "https://forexapi.ibrlive.com/api-documentation.txt",
    title: "IBR Live Forex API documentation (plain text)",
  },
];

const Documentation = () => {
  useEffect(() => {
    const created = MACHINE_READABLE_LINKS.map((link) => {
      const el = document.createElement("link");
      el.rel = link.rel;
      el.type = link.type;
      el.href = link.href;
      el.title = link.title;
      document.head.appendChild(el);
      return el;
    });

    let meta = document.querySelector('meta[name="doc-machine-readable"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "doc-machine-readable";
      meta.content = "https://forexapi.ibrlive.com/api-documentation.html";
      document.head.appendChild(meta);
    }

    return () => {
      created.forEach((el) => el.remove());
      meta?.remove();
    };
  }, []);

  return (
    <div className="api-doc-page">
      <iframe
        src="/api-documentation.html"
        title="IBR Live Forex API Documentation"
        className="api-doc-embed"
      />
    </div>
  );
};

export default Documentation;
